import {Component, Input} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {StandingsService} from "../../../services/standings.service";
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbInputModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToastrService
} from "@nebular/theme";
import {notificationsParams} from "../../settings";
import {FormInputComponent} from "../forms/form-input/form-input.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-standings-form',
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule,
    NbButtonModule,
    ReactiveFormsModule,
    NbSelectModule,
    NbInputModule,
    NbSpinnerModule,
    FormInputComponent,
    NbCardModule
  ],
  templateUrl: './standings-form.component.html',
  styleUrl: './standings-form.component.scss'
})
export class StandingsFormComponent {
  private data: any;
  loading = false;

  standingsForm = new FormGroup({
    game_wins: new FormControl('', [Validators.required]),
    game_losses: new FormControl('', [Validators.required]),
    map_wins: new FormControl('', [Validators.required]),
    map_losses: new FormControl('', [Validators.required]),
  });

  @Input() standings_id: any;
  @Input() group_id: any;
  @Input() division_id: any;
  @Input() team_id: any;

  constructor(private standingsService: StandingsService, private toastrService: NbToastrService, protected dialogRef: NbDialogRef<any>) {}

  ngOnInit(): void {
    if (this.standings_id) {
      const search_params= { standings_id: this.standings_id, team_id: this.team_id }
      this.standingsService.show(search_params).subscribe(data => {
        this.data = data;
        this.standingsForm.patchValue({
          game_wins: data.game_wins,
          game_losses: data.game_losses,
          map_wins: data.map_wins,
          map_losses: data.map_losses,
        });
      });
    }
  }

  submit() {
    this.loading = true;
    let submittedData: any = this.standingsForm.value;
    submittedData.standings_id = this.data?.standings_id;
    submittedData.group_id = this.group_id;
    submittedData.division_id = this.division_id;
    submittedData.team_id = this.team_id;
    this.standingsService.createOrUpdate(submittedData).subscribe(() => {
      this.toastrService.success('Updated successfully', 'Information', notificationsParams);
      this.dialogRef.close();
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  getControl(controlName: string): FormControl {
    return this.standingsForm.get(controlName) as FormControl;
  }
}
